import { createContext, useContext, type ReactNode } from "react";
import type { AppMessages } from "./messages.js";
import { getMessages } from "./messages.js";
import { DEFAULT_LOCALE, normalizeTelegramLocale, type SupportedLocale } from "./locale.js";

const LocaleContext = createContext<{ locale: SupportedLocale; messages: AppMessages }>({
  locale: DEFAULT_LOCALE,
  messages: getMessages(DEFAULT_LOCALE),
});

export function LocaleProvider({
  languageCode,
  children,
}: {
  languageCode?: string | null;
  children: ReactNode;
}) {
  const locale = normalizeTelegramLocale(languageCode);
  const messages = getMessages(locale);
  return (
    <LocaleContext.Provider value={{ locale, messages }}>{children}</LocaleContext.Provider>
  );
}

export function useLocale() {
  return useContext(LocaleContext);
}

export function useMessages(): AppMessages {
  return useContext(LocaleContext).messages;
}
